import type { EntityConfig } from '../types'

export const securityEventEntity: EntityConfig = {
  id: 'security-event',
  displayName: 'Security Event',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'success', label: 'Success' },
      { value: 'failure', label: 'Failure' },
      { value: 'warning', label: 'Warning' },
    ],
    options: [
      { value: 'success', label: 'Success', color: 'success' },
      { value: 'failure', label: 'Failure', color: 'error' },
      { value: 'warning', label: 'Warning', color: 'pending' },
    ],
    mappings: {
      all: ['success', 'failure', 'warning'],
      success: ['success'],
      failure: ['failure'],
      warning: ['warning'],
    },
  },
  queryFields: {},
  uiFilterFields: ['search', 'status', 'eventType', 'dateRange'],
}
